import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Paper from '@mui/material/Paper';
import {
  Link,
  Redirect,
  Route,
  Switch,
  useLocation,
  generatePath,
  useParams,
} from 'react-router-dom';
import { ManageNumbers } from './ManageNumbers';
import { BlockedNumbers } from '../subpages/BlockedNumbers';
import InboundCallRouting from '../subpages/inboundCallRouting';
import InboundCallRoutingModal from '../components/modals/InboundCallRoutingModal';
import BusinessSMSInbox from '../subpages/business-sms/BusinessSMSInbox';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  tabs: {
    borderBottom:
      theme.palette.mode === 'dark' ? '1px solid #515151' : '1px solid #e0e0e0',
    indicator: {
      backgroundColor: '#0098C7',
    },
  },
  tab: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&[aria-selected=true]': {
      color: '#0098C7',
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  paper: {
    flexGrow: 1,
  },
}));

export function NumberTabs({ basePath = '/manage/numbers' }) {
  const classes = useStyles();
  const location = useLocation();
  const { id } = useParams();
  const businessSmsEnabled = process.env.VITE_APP_BUSINESS_SMS === '1';
  const pages = {
    blocked: {
      pathname: `${basePath}/blocked`,
    },
    unblocked: {
      pathname: `${basePath}/unblocked`,
    },
    routing: {
      pathname: `${basePath}/routing`,
    },
    editRouting: {
      pathname: `${basePath}/routing/:id/edit`,
    },
    deleteRouting: {
      pathname: `${basePath}/routing/:id/delete`,
    },
    businessSmsInbox: {
      pathname: `${basePath}/business-sms`,
    },
    editBusinessSmsInbox: {
      pathname: `${basePath}/business-sms/:id/edit`,
    },
    deleteBusinessSmsInbox: {
      pathname: `${basePath}/business-sms/:id/delete`,
    },
  };
  return (
    <Paper className={classes.root}>
      {location.pathname !== basePath &&
        location.pathname !== `${basePath}/` && ( // on initial load prevent render since basePath tab undefined
          <Tabs
            className={clsx(classes.tabs, 'dtStep7')}
            value={
              location?.pathname?.includes('routing')
                ? generatePath(pages?.routing?.pathname, { id })
                : location.pathname
            }
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            {process.env.VITE_APP_FEATURE_BLOCKED_NUMBERS === '1' && (
              <Tab
                className={classes.tab}
                label="Blocked"
                data-pup="blocked-numbers-tab"
                component={Link}
                value={pages.blocked.pathname}
                to={{
                  pathname: pages.blocked.pathname,
                  search: location.search,
                }}
              />
            )}
            <Tab
              className={classes.tab}
              label="Numbers"
              data-pup="unblocked-numbers-tab"
              component={Link}
              value={pages.unblocked.pathname}
              to={{
                pathname: pages.unblocked.pathname,
                search: location.search,
              }}
            />
            <Tab
              className={classes.tab}
              label="Routing"
              component={Link}
              value={pages.routing.pathname}
              to={{
                pathname: pages.routing.pathname,
                search: location.search,
              }}
            />
            {businessSmsEnabled && (
              <Tab
                className={classes.tab}
                label="Team SMS"
                component={Link}
                value={pages.businessSmsInbox.pathname}
                to={{
                  pathname: pages.businessSmsInbox.pathname,
                  search: location.search,
                }}
              />
            )}
          </Tabs>
        )}
      <Switch>
        <Redirect
          exact
          from={basePath}
          to={{
            pathname: pages.unblocked.pathname,
            search: location.search,
          }}
        />
        <Route
          path={pages.unblocked.pathname}
          render={(props) => <ManageNumbers />}
        />
        <Route
          path={pages.blocked.pathname}
          render={(props) => <BlockedNumbers />}
        />
        <Route
          path={pages.routing.pathname}
          render={(props) => <InboundCallRouting />}
        />
        <Route path={pages.editRouting.pathname}>
          {({ history, match }) => (
            <InboundCallRoutingModal show={match !== null} />
          )}
        </Route>
        <Route
          path={pages.businessSmsInbox.pathname}
          render={(props) => <BusinessSMSInbox />}
        />
      </Switch>
    </Paper>
  );
}
